// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-module--root--aZeph","icon":"icon-module--icon--1ihz7","label":"icon-module--label--fHC-f"};